import { render } from "./CreditorStatement.vue?vue&type=template&id=dee1508e"
import script from "./CreditorStatement.vue?vue&type=script&lang=js"
export * from "./CreditorStatement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__